export const APPOINTMENT_CRITERIA = {
	reasonForVisit: "reasonForVisit",
	agentAvailabilityInstructions: "agentAvailabilityInstructions",
	agentReservationInstructions: "agentReservationInstructions",
	agentPostBookingInstructions: "agentPostBookingInstructions",
}